import { render } from "./tableData.vue?vue&type=template&id=3b0d525a&scoped=true&ts=true"
import script from "./tableData.vue?vue&type=script&lang=ts"
export * from "./tableData.vue?vue&type=script&lang=ts"

import "./tableData.vue?vue&type=style&index=0&id=3b0d525a&scoped=true&lang=css"
import "./tableData.vue?vue&type=style&index=1&id=3b0d525a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0d525a"]])

export default __exports__